import { gql } from '@apollo/client';
import ErrorResultFragment from "../../fragments/ErrorResult";

const UPDATE_WORKSPACE_TEXT_EDITOR_CONTENT = gql`
  mutation UpdateWorkspaceTextEditorContent(
    $siteId: Int!
    $textkey: String
    $culture: String
    $contents: String
  ) {
    widgetsContext {
      updateWorkspaceTextEditorContent(
        siteId: $siteId
        textkey: $textkey
        culture: $culture
        contents: $contents
      ) {
        errorResult {
          ...ErrorResultFields
        }
        success
        result
      }
    }
  }
  ${ErrorResultFragment}
`;

export default UPDATE_WORKSPACE_TEXT_EDITOR_CONTENT;
